import React from 'react';

type DisplayComponentProps = {
  children: React.ReactNode;
};

export function InvoiceFormCell({ children }: DisplayComponentProps) {
  return <td className="px-6 py-4">{children}</td>;
}
